export const AIRCALL = 36503;
export const MOCK_UI = 0;
export const appIds = {
  AIRCALL: 36503,
  MOCK_UI: 0
};